import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { ArquivoAnaliseDeRisco } from '../domain/arquivo-analise-de-risco.model';

export class ArquivoAnaliseDeRiscoSerializer extends DomainSerializer<ArquivoAnaliseDeRisco> {}
